<template>
    <div v-if="!loading">
        <highcharts
            :constructor-type="'chart'"
            :options="chartOptions"
            class="chart"
            ref="highcharts"
        ></highcharts>
    </div>
    <div class="text-center pt-3 pb-3" v-else>
        <img src="loader.svg" style="width: 100px; height: 100px" />
    </div>
</template>

<script>
import Utils from '@/utils'

import { curvesColorsCharts } from './colorsCharts.js'
import ChartsConfig from '@/mixins/Charts.Config.js'

export default {
    props: {
        data: {
            type: [Array]
        },
        loading: {
            type: [Boolean]
        },
        onPointClick: {
            type: [Function]
        }
    },
    data() {
        return {
            chart_offsetWidth: null,
            chart_offsetHeight: null,
            class_info: null,
            chartOptions: {
                className: 'stock',
                chart: {
                    type: 'bar',
                    className: 'cubage_chart_resize',
                    height: 800
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: 'Valores'
                    },
                    labels: {
                        formatter: function() {
                            return Utils.formatNumber(this.value, 'float', true)
                        }
                    }
                },
                tooltip: {
                    formatter: function() {
                        return `${this.x}<br/>
                        <span style="color:${this.color}">\u25CF</span>
                        ${this.series.name}: <b>${Utils.formatNumber(
                            this.y,
                            'float',
                            true
                        )}</b>`
                    }
                },
                title: {
                    text: 'Cubagem dos CDs'
                },
                plotOptions: {
                    series: {
                        stacking: 'normal',
                        pointWidth: 20,
                        dataLabels: {
                            enabled: true,
                            inside: true,
                            formatter: function() {
                                return Utils.formatNumber(this.y, 'float', true)
                            }
                        },
                        events: {
                            click: event => {
                                if (event.point.formatPrefix === 'point') {
                                    this.onPointClick(
                                        event.point.series.name,
                                        event.point.category
                                    )
                                } else {
                                    let curve = event.point.category
                                    let colorIndex = event.point.colorIndex

                                    let elem =
                                        colorIndex <
                                        Object.keys(this.column_keys).length
                                            ? Object.keys(this.column_keys)[
                                                colorIndex
                                                ]
                                            : Object.keys(this.line_keys)[
                                            colorIndex -
                                            Object.keys(
                                                this.column_keys
                                            ).length
                                                ]
                                    this.onClick(curve, elem)
                                }
                            },

                            legendItemClick: function() {
                                if (!this.visible) {
                                    this.chart.series[this.index].show()
                                } else {
                                    let check = false

                                    if (this.index <= 4)
                                        check = this.chart.series.some(
                                            (serie, index) =>
                                                !serie.visible &&
                                                this.index <= 4 &&
                                                index <= 4
                                        )
                                    else
                                        check = this.chart.series.some(
                                            (serie, index) =>
                                                !serie.visible &&
                                                this.index > 4 &&
                                                index > 4
                                        )

                                    if (!check) {
                                        this.chart.series.map(
                                            (serie, index) => {
                                                if (index === this.index)
                                                    serie.show()
                                                else if (
                                                    this.index <= 4 &&
                                                    index <= 4
                                                )
                                                    serie.hide()
                                                else if (
                                                    this.index > 4 &&
                                                    index > 4
                                                )
                                                    serie.hide()
                                            }
                                        )
                                    } else {
                                        this.chart.series.map(
                                            (serie, index) => {
                                                if (
                                                    this.index <= 4 &&
                                                    index <= 4
                                                )
                                                    serie.show()
                                                else if (
                                                    this.index > 4 &&
                                                    index > 4
                                                )
                                                    serie.show()
                                            }
                                        )
                                    }
                                }

                                return false
                            }
                        }
                    }
                },
                series: []
            }
        }
    },
    mixins: [ChartsConfig],
    watch: {
        data: {
            handler: function(data) {
                this.$nextTick(() => {
                    if (this.$refs.highcharts.chart) {
                        const chart = this.$refs.highcharts.chart
                        let dcs = []
                        let curves = curvesColorsCharts().histogram()

                        while (chart.series.length) {
                            chart.series[0].remove()
                        }

                        data[0].map(item => {
                            if (item.dc_external_id) {
                                dcs.push(item.dc_external_id)

                                item.curves.map(curve => {
                                    const index = curves.findIndex(c => c.name === curve.curve)
                                    const cubage = data[1].isChecked ? curve.stock_cubage : curve.total_without_new_cubage

                                    if (index > -1) {
                                        curves[index].data.push(cubage || 0)
                                    }

                                })
                            }
                        })

                        chart.xAxis[0].setCategories(dcs)

                        curves.map(curve => {
                            chart.addSeries(curve)
                        })
                    }
                })
            },
            deep: true
        }
    }
}
</script>
<style scoped>
.highcharts-figure,
.highcharts-data-table table {
    min-width: 310px;
    max-width: 800px;
    margin: 1em auto;
}

.highcharts-data-table table {
    font-family: Verdana, sans-serif;
    border-collapse: collapse;
    border: 1px solid #ebebeb;
    margin: 10px auto;
    text-align: center;
    width: 100%;
    max-width: 500px;
}

.highcharts-data-table caption {
    padding: 1em 0;
    font-size: 1.2em;
    color: #555;
}

.highcharts-data-table th {
    font-weight: 600;
    padding: 0.5em;
}

.highcharts-data-table td,
.highcharts-data-table th,
.highcharts-data-table caption {
    padding: 0.5em;
}

.highcharts-data-table thead tr,
.highcharts-data-table tr:nth-child(even) {
    background: #f8f8f8;
}

.highcharts-data-table tr:hover {
    background: #f1f7ff;
}
</style>
